import styled from 'styled-components';

export const List = styled.div`
  width: 80%;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 4%;
`;
